const KEY = 'PUSH';

export { KEY };
